import React from "react";
import { cn } from "@/lib/utils";

const COLORS = ["bg-[#006090]", "bg-[#0093D6]", "bg-indigo-600", "bg-sky-600", "bg-violet-600", "bg-rose-500"];

export function UserAvatar({ name, size = 36, className }) {
  const initials = (name || "?")
    .split(" ").filter(Boolean).slice(0, 2).map((n) => n[0].toUpperCase()).join("");
  const color = COLORS[(name || "").length % COLORS.length];
  return (
    <span
      className={cn("inline-flex items-center justify-center rounded-full text-white font-semibold", color, className)}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {initials}
    </span>
  );
}
